import { Button, Card, CardContent, CardHeader, Divider, Grid, makeStyles, TextField } from '@material-ui/core'
import React, { useState } from 'react'

const useStyles = makeStyles(theme => ({
    root: {
        background: '#f1f1f1',
        flexGrow: 1,
        marginBottom: theme.spacing(6)
    },
}))


const ContractorSearch = props => {
    const classes = useStyles()
    const [value, setValue] = useState('')
    return (
        <Card elevation={5} className={classes.root}>
            <CardHeader
                title='جستجو'
            />
            <Divider />
            <CardContent>
                <Grid container xs={12}>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label="جستجو در نام، شناسه ملی و کد اقتصادی"
                            onChange={event => setValue(event.target.value)}
                            value={value}
                            onKeyPress={event => {
                                if (event.key === 'Enter') {
                                    props.setSearch(value)
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={6} style={{ alignSelf: 'center' }}>
                        <Button
                            variant='contained'
                            color='primary'
                            onClick={() => props.setSearch(value)}
                        >
                            جستجو
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default ContractorSearch